import { CONFIG_NAME_GPIO } from "./constants";
import { deepCopy, filterOptions } from "./utils";

export function configGpio(state, pin, modeName) {

    const gpio = state.config[CONFIG_NAME_GPIO];

    if (gpio) {
        const fields = [];
            
        const mode = gpio.modes.find(m => m.name === modeName);
        if (mode) {
            
            for (const p of mode.parameters) {
                // console.log(p);
                let field = gpio.parameters.find(_p => _p.name === p.name);
                if (field) {
                    field = deepCopy(field);
                    if (p.options) {
                        field.options = filterOptions(field.options, p.options);
                    }

                    if (p.value) {
                        field.value = p.value;
                    } else if (field.default) {
                        field.value = field.default
                    } else if (field.options && field.options.length === 1) {
                        field.value = field.options[0].value;
                    }

                    if (p.hasOwnProperty('visible')) {
                        field.visible = p.visible
                    }

                    fields.push(field);
                } else {
                    console.error(`field not found: ${p.name}`)
                }
            }
        }

        let gpioPin = gpio.pins.find(p => p.name === pin.name);
        if (gpioPin) {

            fields.push({
                name: 'GPIO_Pin',
                value: gpioPin.GPIO_Pin,
                visible: false
            })

            const port = gpio.ports.find(p => p.name === gpioPin.port)
            if (port) {
                fields.push({
                    name: 'GPIOx',
                    value: port.GPIOx,
                    visible: false
                })
            }
        }

        const pinCopy = deepCopy(pin);

        pinCopy.fields = fields;

        return pinCopy;
    }
}
